import { Ratings } from "@/api/AppApi/services/home/interfaces/IProduct";

import Separator from "@/app/components/lib/Separator";
import ReviewDetails from "@/app/components/review-product/current-reviews/ReviewDetails";
import {
  productReviewsPopupAtoms,
  submitproductReviewPopupAtoms,
} from "@/hooks/headerHooks";
import { useTranslation } from "@/hooks/localization/useTranslations";
import usePopup from "@/hooks/usePopup";

interface Props {
  rate: number;
  mobile: boolean;
  ratings: Ratings;
  productId: string | number;
  canReview: boolean;
}
const ProductDetailsReview: React.FC<Props> = ({
  mobile,
  rate,
  ratings,
  productId,
  canReview,
}) => {
  const { handleOpenPopup } = usePopup(productReviewsPopupAtoms);
  const { handleOpenPopup: handleOpenWriteReviewPopup } = usePopup(
    submitproductReviewPopupAtoms,
  );
  const mClass = mobile ? "-mobile" : "";
  const t = useTranslation();
  return (
    <div className={`product-details-review-block${mClass} mt-4`}>
      {mobile && (
        <Separator
          startLabel={t.item_review}
          marginBottom={0}
          endLabel={
            canReview
              ? {
                  label: t.write_your_review,
                  onClick: () => {
                    handleOpenWriteReviewPopup({
                      product_id: productId,
                    });
                  },
                }
              : undefined
          }
        />
      )}
      <ReviewDetails productDetails rate={rate} ratings={ratings} />
      <div
        className="see-all-reviews"
        onClick={() => {
          handleOpenPopup({ product_id: productId, rate, ratings, canReview });
        }}
      >
        {t.see_all_reviews}
      </div>
    </div>
  );
};

export default ProductDetailsReview;
